/**
 * Conta quantas vezes um card mudou de etapa.
 *
 * Auditoria 2026-08-08 (F24): o painel lia só `item.activities` — associação
 * que o `as_json` do card não inclui — e o número ficava sempre em 0.
 *
 * O histórico chega em três lugares diferentes, com formatos diferentes:
 *   - `item_details.history`    (append-only, gravado pelo backend)
 *   - `item_details.activities` (timeline do cliente)
 *   - `item.activities`         (associação, quando carregada)
 *
 * Elas NÃO compartilham identidade de evento: ids são locais de cada fonte
 * (quando existem) e os campos de transição mudam de nome. Por isso aqui não
 * há merge nem deduplicação — contar é diferente de exibir. O ActivityTab
 * mescla tudo porque quer mostrar a linha do tempo completa.
 *
 * São espelhos com completude variável (migração, sincronização parcial), e a
 * melhor estimativa é o MAIOR entre eles: somar contaria a mesma transição
 * mais de uma vez, e pegar a primeira fonte não-vazia subcontaria quando ela
 * estivesse incompleta.
 */

const isStageChangeEntry = entry =>
  entry?.type === 'stage_changed' || entry?.activity_type === 'stage_changed';

export const stageChangeSources = item => [
  item?.item_details?.history,
  item?.item_details?.activities,
  item?.activities,
];

export const countStageChanges = item =>
  Math.max(
    0,
    ...stageChangeSources(item)
      .filter(Array.isArray)
      .map(source => source.filter(isStageChangeEntry).length)
  );

export default countStageChanges;
